import {useQuery} from '@tanstack/react-query';
import api from '@/api/config';
import {useParams} from 'react-router-dom';

export const useCollectionStats = () => {
  const {username} = useParams();

  return useQuery({
    queryKey: ['collection', username],
    queryFn: async () => {
      const response = await api.get('/users/user-collection-stats/');
      return response.data;
    },
  });
};

export const useGetUserDecks = () => {
  const {username} = useParams();

  return useQuery({
    queryKey: ['userDecks', username],
    queryFn: async () => {
      const response = await api.get(`cards/decks/?user=${username}`);
      return response.data;
    },
  });
};